import { api } from './client.js';

/** 못 읽은 줄 */
export interface SkippedLine {
  line: number;
  text: string;
  why: string;
}

/** 원본 market_ga_insert.php */
export interface GaRow {
  sess: string;
  ldate: string;
  ltime: number;
  lweek: number;
  visit: number;
  ord: number;
  sale: number;
}

export interface GaPreview {
  rows: GaRow[];
  updating: number;
  inserting: number;
  skipped: SkippedLine[];
}

/** 원본 domain_rank_check.php */
export interface DomainRow {
  domainUs: string;
  domainKr: string;
  duplicate: boolean;
}

export interface DomainPreview {
  rows: DomainRow[];
  duplicates: number;
  fresh: number;
  skipped: SkippedLine[];
}

export const importsApi = {
  previewGa: (text: string) => api.post<GaPreview>('/imports/ga/preview', { text }),
  commitGa: (text: string) => api.post<{ written: number }>('/imports/ga/commit', { text }),

  previewDomains: (text: string) => api.post<DomainPreview>('/imports/domains/preview', { text }),
  commitDomains: (text: string, downFileName: string, skipExisting: boolean) =>
    api.post<{ written: number; skippedExisting: number }>('/imports/domains/commit', {
      text,
      downFileName,
      skipExisting,
    }),
};
